import React from 'react';
import { Search } from '../../../components/Search';
import AssignTo from './AssignTo.tsx';

import styles from './UnassignedAccounts.module.scss';

const UnassignedAccountsHeader = ({ search, setSearch, selectedAccounts }) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerLeft}>
        {selectedAccounts?.length ? <AssignTo selectedAccounts={selectedAccounts} /> : null}
      </div>

      <div className={styles.headerRight}>
        <Search search={search} setSearch={setSearch} isDebounce />
      </div>
    </div>
  );
};

export default UnassignedAccountsHeader;
